var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-input',{class:_vm.customClass,attrs:{"label":_vm.label,"value":_vm.maskedValue,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"change":_vm.change,"input":_vm.input,"blur":_vm.blur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }